<template>
	<div class="allbg">
		<!-- 头 -->
		<tyheader pageind="2"/>
		<section class="n_banner" :style=" 'background:url('+bannerurl+') center no-repeat;'"></section>
		<section class="n_title n_title01">
			<div class="w1400 pagetit">
				<div class="left">
					<div class="n_nav">
						<a v-for="(item, index) in newsmenu" :key="index" :class="{on:newstabind == index}" @click="otherrout(item.code,index)" style="cursor: pointer;"><strong>{{item.title}}</strong></a>
						<!-- <a href="#"><strong>媒体报道</strong></a>
						<a href="#"><strong>双沟酒讯</strong></a>
						<a href="#"><strong>行业动态</strong></a>
						<a href="#"><strong>视频中心</strong></a>
						<a href="#"><strong>集团公告</strong></a>
						<a href="#"><strong>招标信息</strong></a> -->
					</div>
				</div>
				<div class="right ">
					<div class="position"><a href="/">首页</a> <i>-</i> <a href="/news?type=&index=1">动态资讯</a> <i>-</i> <em>{{newstabname}}</em> </div>
				</div>
			</div>
		</section>
		<section class="n_container">
			<div class="w1400" :class="isshow?'newspc':'newsph'">
				<div class="news-container news-ny clearfix">
					<div v-for="(item, index) in newslist" :key="index" class="item">
						<router-link class="nav-link" :to="{path:'/newsdetail',query: {code: item.code,ind:newstabind}}">
						<div class="wrap">
							<div class="insteada">
								<div class="pic">
									<img :src="item.showImage">
									<span>{{item.time}}</span>
								</div>
								<h2 class="title" :title="item.title">{{item.title}}</h2>
								<p class="intro">{{item.intro}}</p>
								<div class="btn"><div class="tryani"><span>查看详细</span><i></i></div></div>
							</div>
						</div>
						</router-link>
					</div>
				</div>
				<!--分页-->
				<div class="page-bar">
					<ul>
						<li v-if="cur>1"><a v-on:click="cur--,pageClick()">上一页</a></li>
						<li v-if="cur==1"><a class="banclick">上一页</a></li>
						<li v-if="isshow" v-for="index in indexs" v-bind:class="{ 'active': cur == index}">
							<a v-on:click="btnClick(index)">{{ index }}</a>
						</li>
						<li v-if="cur!=all"><a v-on:click="cur++,pageClick()">下一页</a></li>
						<li v-if="cur == all"><a class="banclick">下一页</a></li>
						<li><a>共<i>{{all}}</i>页</a></li>
					</ul>
				</div>
			</div>
		</section>
		<tyfooter></tyfooter>
	</div>
</template>

<script>
	import tyheader from './header.vue'
	import tyfooter from './footer.vue'
	// import { Loading } from 'element-ui';
	// let forloadingmod = Loading.service();
	export default {
	  name: 'product',
		components: {
			tyheader,
			tyfooter
		},
		metaInfo () {
			return {
				title: this.seot,
				meta: [   // set meta
					{                
						name: 'keyWords',
						content: this.seok
					},
					{
						name: 'description',
						content: this.seod
					}
				]
			}
		},
		data(){
			return{
				seot:this.COMMON.seotit,
				seod:this.COMMON.seodec,
				seok:this.COMMON.seokey,
				isshow:this.COMMON.isshow(),
				imgurl:this.COMMON.imgurl,
				newsmenu:[],
				newstabind:0,
				newstabname:'',
				newslist:[],
				bannerurl:'',
				oldcode:'',
				menuindex:'',
				all: 7, //总页数
				cur: 1,//当前页码
				totalPage: 0,//当前条数
			}
		},
		computed:{
			//分页
			indexs: function(){
				var left = 1;
				var right = this.all;
				var ar = [];
				if(this.all>= 5){
					if(this.cur > 3 && this.cur < this.all-2){
						left = this.cur - 2
						right = this.cur + 2
					}else{
						if(this.cur<=3){
							left = 1
							right = 5
						}else{
							right = this.all
							left = this.all -4
						}
					}
				}
				while (left <= right){
					ar.push(left)
					left ++
				}
				return ar
			}
		},
		mounted() {
			let that = this
			let artcode = this.$route.query.type
			let artind = this.$route.query.ind
			let menuindex = this.$route.query.index
			that.oldcode = this.$route.query.type
			that.newstabind = this.$route.query.ind
			that.menuindex = this.$route.query.index
			// 新闻
			this.getmenulist()
			that.$axios.post('/w/menu').then(function (response) {
				that.bannerurl = that.imgurl + response.data[1].banner
			}).catch(function (error) {
					console.log(error);
			});
			that.$axios.post('/w/pageseo?address='+'/news').then(function (response) {
				if(JSON.stringify(response.data) != "{}"){
					that.seot = response.data.seoTitle
					that.seok = response.data.seoKey
					that.seod = response.data.seoDes
				}
			}).catch(function (error) {
					console.log(error);
			});
			
		},
		methods:{
			getnewslist(num,ind){
				let that = this
				let amount = that.isshow ? 8 : 4
				this.$axios.post('/w/art?code=&&amount='+amount+'&&page='+that.cur+'&&menuCode='+num).then(function (response) {
					response.data.list.forEach((val,ind) => {
						val.showImage = that.imgurl + val.showImage
						val.time = val.time.split(' ')[0]
					})
					that.newslist = response.data.list
					that.newstabind = ind
					that.newstabname = response.data.list[0].menu
					that.all = response.data.totalpage
					// forloadingmod.close()
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			getmenulist(){
				let that = this
				this.$axios.post('/w/menu?code=1631172414011').then(function (response) {
					if(that.oldcode && that.newstabind){
						that.getnewslist(that.oldcode,that.newstabind)
					}else{
						that.oldcode = response.data[0].code
						that.newstabind = 0
						that.getnewslist(response.data[0].code,0)
					}
					that.newsmenu = response.data
					
				})
				.catch(function (error) {
					console.log(error);
				});
			},
			otherrout(num,ind){
				this.$router.push({path:'/news',query: {type:num,ind:ind}})
			},
			
			//分页
			btnClick: function(data){//页码点击事件
				// forloadingmod
				if(data != this.cur){
					this.cur = data
				}
				// //根据点击页数请求数据
				this.getnewslist(this.oldcode,this.newstabind);
			},
			pageClick: function(){
				// forloadingmod
				//根据点击页数请求数据
				this.getnewslist(this.oldcode,this.newstabind);
			}
		},
		watch:{
			$route(){
				this.oldcode = this.$route.query.type
				this.newstabind = this.$route.query.ind
				this.getmenulist()
			},
		}
	}
</script>

<style scoped="scoped">
	article, aside, footer, header, nav, section {display: block;}
	img {
	    border-style: none;
	    max-width: 100%;
	    vertical-align: top;
	    width: auto!important;
	    height: auto!important;
	}
	.n_banner {height: 70vh;background-size: cover !important;}
	.n_title {height: 74px;border-bottom: #e7e7ea 1px solid;padding: 0;position: relative;background: #fff;}
	.pagetit{display: flex;justify-content: space-between;}
	.n_nav {position: relative;}
	.n_nav a {display: inline-block;height: 74px;font-size: 18px;float: left;line-height: 75px;color: #333333;text-align: center;box-sizing: border-box;position: relative;-moz-border-radius: 3px;-webkit-border-radius: 3px;border-radius: 3px;margin-right: 3.125rem;}
	.n_nav a:before {content: "";width: 0;height: 3px;position: absolute;bottom: 0;left: 0;background: #119e7f;transition: 0.6s ease-in-out;}
	.n_nav .on:before, .n_nav a:hover:before {width: 100%;}
	.position {line-height: 74px;color: #7b7b7d;padding-left: 22px;font-size: 14px;background: url(../assets/images/home_icon.png) left 30px no-repeat;}
	.position i {
		margin: 0px 5px;
		font-style: normal;
	}
	.position span, .position a, .position i {
		font-size: 14px;
		color: #7b7b7d;
		-moz-transition: all 0.36s ease-in-out;
		-webkit-transition: all 0.36s ease-in-out;
		-o-transition: all 0.36s ease-in-out;
		-ms-transition: all 0.36s ease-in-out;
		transition: all 0.36s ease-in-out;
	}
	.position em {
		font-size: 14px;
		color: #acacac;
		font-style: normal;
	}
	.n_container {
		background: url(../assets/images/n_container_bg.jpg) center bottom no-repeat #fff;
		background-size: 100% auto;
		width: 100%;
	}
	.news-ny {
	    padding-top: 60px;
	}
	.news-container .item {
		border-bottom: 0px;
	}
	.insteada .pic span {
	    display: block;
	    position: absolute;
	    left: 0;
	    bottom: 0;
	    font-size: 12px;
	    color: #fff;
	    width: 90px;
	    height: 30px;
	    text-align: center;
	    line-height: 30px;
	    background-color: #119e7f;
	}
	
	
	.newsph .news-container .item {width: 100%;background-color: rgb(255,255,255,0);border-bottom: 1px solid #e2e2e2;}
	.newsph .news-container a{padding-right: 0px;}
	.newsph .news-container .btn{display: block;}
	@media screen and (max-width: 767px) {
		.n_title{height: 50px;}
		.n_nav a{height: 50px;line-height: 50px;}
		.position{line-height: 50px;background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAMCAYAAAC5tzfZAAAAuElEQVQokZXRoU4DQRQF0LOT0RtCkKTB9Qdo+QY0hg+ApAKaFQj6G8XVUlldW40kCMjK6josEMxsMkyWQK95L3PnJJNM1TSNnsxwh0XafyT2gDlu036PI1znF0IBVhnocoV1H6rxhIu+t+I89YcdOsMLxr+ALmM8YxSwxOAP0OUYjwGX+PgngknAK772QG3EAaqieECLIW6Kro4JlGia7SWqQgLlJ58UM0+M2GGD06z4zOZ7dv6G7TfQZhwU9L0NbQAAAABJRU5ErkJggg==) left 19px no-repeat;}
	  .left{width: 7rem;
    height: 50px;
    overflow: hidden;}
		.left{background: url(../assets/images/downarr.png) right 15px no-repeat ;background-size: 20px;}
		.left:hover{height:auto;background: url(../assets/images/downarr.png) right 15px no-repeat #ffffff;background-size: 20px;box-shadow: 0px 0px 10px rgb(0,0,0,0.5);}
	}
	
	/*分页*/
	.page-bar{
		margin:0px auto;
		display: flex;
	  justify-content: center;
		padding-bottom: 40px;
	}
	ul,li{
		margin: 0px;
		padding: 0px;		display: flex;
	}
	li{
		list-style: none
	}
	.page-bar li:first-child>a {
		margin-left: 0px
	}
	.page-bar a{
		border: 1px solid #ddd;
		text-decoration: none;
		position: relative;
		float: left;
		padding: 6px 12px;
		margin-left: -1px;
		line-height: 1.42857143;
		color: #5D6062;
		cursor: pointer;
		margin-right: 20px;
		background-color: #ffffff;
	}
	.page-bar a:hover{
		background-color: #eee;
	}
	.page-bar a.banclick{
		cursor:not-allowed;
	}
	.page-bar .active a{
		color: #fff;
		cursor: default;
		background-color: #119e7f;
		border-color: #119e7f;
	}
	.page-bar i{
		font-style:normal;
		color: #119e7f;
		margin: 0px 4px;
		font-size: 12px;
	}
</style>
